export default __webpack_public_path__ + "static/media/fir_slogan.7906b2db.png";